import * as React from 'react';

import { ContextService } from 'src/core/services/context.service';
import { ContactPartController } from 'src/app/crm/contacts/parts/contact-part.controller';

interface Props extends ComponentViewProps<ContactItem[]> {
	parentModel: AgentItem;
	mode: ControlMode;
	contextService: ContextService;
}

export class AgentContactPartView extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	render() {
		const {
			model, parentModel,
			contextService, mode, setBusy
		} = this.props;
		if (model == null) {
			return null;
		}

		return (
			<ContactPartController
				parentModel={parentModel}
				model={model}
				mode={mode}
				setBusy={setBusy}
				contextService={contextService}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agents/form/parts/agent-contact.view.tsx